<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <main class="main-content position-relative border-radius-lg ">
      <!-- Navbar -->
      <HeaderMenu></HeaderMenu>
      <!-- End Navbar -->
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <div v-for="(notification, index) in notifications" :key="index" class="alert position-fixed top-0 end-0 m-3"
          :class="notification.class" role="alert" style="color: white; z-index: 9999; max-width: 360px;">
          {{ notification.message }}
          <button style="font-size: small" type="button" class="btn-close" @click="closeNotification(index)"
            aria-label="Close"></button>
        </div>


        <div class="row">
          <div class="col-lg-8">
            <div class="card mb-4">
              <div class="card-header pb-0 d-flex align-items-center gap-2">
                <img 
                  :src="getFileIcon()" 
                  :alt="getFileIconAlt()"
                  class="file-icon-header"
                  style="width: 36px; height: 36px;"
                />
                <h6 class="mb-0">{{ filename }}</h6>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <div ref="fullscreenDiv">
                    <!-- Visualización del contenido -->
                    <div v-if="fileType === 'pdf'"
                      :class="['pdf-container', { 'pdf-container-completa': isFullscreen }]">
                      <vue-office-pdf v-if="pdfSrc" :src="pdfSrc"
                        :style="{ height: isFullscreen ? '100dvh' : '70vh' }" />
                    </div>

                    <div v-else-if="fileType === 'image'" class="image-container"
                      :style="{ height: isFullscreen ? '100dvh' : 'auto' }">
                      <img :src="imgbase64" alt="Vista previa del archivo" style="max-height: 100%; width: auto;" />
                    </div>
                    <div v-else-if="fileType === 'text'" class="file-container">
                      <pre
                        style="white-space: pre-wrap; font-family: inherit; background: none; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; min-height: 50vh;">{{ textContent }}</pre>
                    </div>
                    <vue-office-docx v-else-if="fileType === 'docx'" :src="docxSrc"
                      :style="{ height: isFullscreen ? '100dvh' : '70vh' }" />
                    <vue-office-excel v-else-if="fileType === 'xlsx'" :src="excelSrc"
                      :style="{ height: isFullscreen ? '100dvh' : '70vh' }" />
                    <div v-else-if="fileType === 'pptx'"
                      :class="['pptx-container', { 'pptx-container-completa': isFullscreen }]">
                      <vue-office-pptx v-if="pptxSrc" :key="`pptx-${fileKey}-${isFullscreen}`" :src="pptxSrc"
                        :style="{ 
                          width: isFullscreen ? '100vw' : '100%', 
                          height: isFullscreen ? '100vh' : '70vh',
                          display: 'block'
                        }" />
                    </div>
                    <div v-else-if="fileType === 'dwg'"
                      style="min-height: 100px; min-width: 100px;"
                      :class="['dwg-container', { 'dwg-container-completa': isFullscreen }]"
                      :style="{ 
                        width: isFullscreen ? '100vw' : '100%', 
                        height: isFullscreen ? '100vh' : '70vh',
                        display: 'block',
                        position: 'relative'
                      }">
                      <VisorCAD2 
                        :base64="dwgBase64 || ''" 
                        :is-fullscreen="isFullscreen"
                        @error="(msg) => showNotification(msg, 'alert-danger')"
                      />
                    </div>
                    <div v-else class="file-container">
                      <p>El archivo no se puede previsualizar. Descárgalo <a @click="descargarArchivo">haciendo clic
                          aquí</a>.
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <button class="btn btn-secondary btn-sm mb-0" @click="descargarArchivo">Descargar
                        documento</button>
                      <button class="btn btn-secondary btn-sm mb-0" @click="pantallaCompleta">Pantalla completa</button>
                    </div>
                  </div>

              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <DetalleDocumento
              v-if="esquema.propiedades && registroSeleccionado.value"
              :esquema="esquema"
              :registro-seleccionado="registroSeleccionado"
              :listas-disponibles="listasDisponibles"
              :show-notification="showNotification"
              :id="esquemaId"
              :hide-document-tab="true"
              @guardar-registro="guardarRegistro"
              @eliminar-registro="onEliminarRegistro"
              @actualizar-registro="handleActualizarRegistro"
            />
          </div>
        </div>
      </div>
    </main>

  </div>
  <!-- Modal de confirmación para eliminar -->
  <div v-if="mostrarModalEliminar" class="modal fade show" tabindex="-1"
    style="display: block; background: rgba(0,0,0,0.3);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar eliminación</h5>
          <button type="button" class="btn-close" @click="mostrarModalEliminar = false"></button>
        </div>
        <div class="modal-body">
          <p>¿Estás seguro de que deseas eliminar este registro?</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="mostrarModalEliminar = false">Cancelar</button>
          <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal Remplazar Documento -->
  <div v-if="mostrarModalRemplazar" class="modal fade show" tabindex="-1"
    style="display: block; background: rgba(0,0,0,0.3);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ esquema.versionado == 1 ? 'Crear Versión' : 'Remplazar Documento' }}</h5>
          <button type="button" class="btn-close" @click="cancelarRemplazar"></button>
        </div>
        <div class="modal-body">
          <input type="file" @change="onFileChangeRemplazar" class="form-control" />
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="cancelarRemplazar">Cancelar</button>
          <button class="btn btn-primary" :disabled="!fileRemplazo" @click="guardarRemplazo">Guardar</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal Relacionar Documento -->
  <div v-if="mostrarModalRelacionar" class="modal fade show" tabindex="-1"
    style="display: block; background: rgba(0,0,0,0.3);"
    @click.self="cerrarRelacionar">
    <div class="modal-dialog modal-lg modal-relacionar">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Relacionar Documento</h5>
          <button type="button" class="btn-close" @click="cerrarRelacionar"></button>
        </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label small">Filtrar por esquema (opcional):</label>
              <select class="form-select form-select-sm" v-model="esquemaBuscar">
                <option :value="null">Todos los esquemas</option>
                <option v-for="esq in esquemasDisponibles" :key="esq.id" :value="esq.id">
                  {{ esq.nombre }}
                </option>
              </select>
            </div>
            <div class="input-group mb-3 align-items-stretch">
              <input type="text" class="form-control" placeholder="Buscar..." v-model="busquedaTermino"
                @keyup.enter="buscarDocumentos">
              <button class="btn btn-outline-secondary mb-0" type="button" @click="buscarDocumentos"
                :disabled="cargandoBusqueda" style="min-width: 100px;">
                <span v-if="cargandoBusqueda" class="spinner-border spinner-border-sm" role="status"
                  aria-hidden="true"></span>
                Buscar
              </button>
            </div>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Fecha</th>
                  <th>Esquema</th>
                  <th class="text-end">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(res, idx) in resultadosBusqueda" :key="'res_' + idx">
                  <td>{{ res.nombre || ('Documento ' + (idx + 1)) }}</td>
                  <td>{{ formatDateTime(res.created_at) || '-' }}</td>
                  <td>
                    <span v-if="res.esquema_id" class="badge bg-info">
                      {{ getEsquemaNombre(res.esquema_id) }}
                    </span>
                    <span v-else class="text-muted">-</span>
                  </td>
                  <td class="text-end">
                    <button class="btn btn-sm btn-primary" @click="relacionarDocumento(res)"
                      :disabled="relacionando">Seleccionar</button>
                  </td>
                </tr>
                <tr v-if="!resultadosBusqueda || resultadosBusqueda.length === 0">
                  <td colspan="4" class="text-center text-secondary">Sin resultados</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="cerrarRelacionar">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu.vue";
import { computed, onMounted, onBeforeUnmount, reactive, ref, watch, useTemplateRef } from "vue";
import { useRouter } from 'vue-router';
import axiosInstance from "@/axios";
import { useRoute } from 'vue-router';
import VueOfficePdf from '@vue-office/pdf'
import VueOfficeDocx from '@vue-office/docx'
import VueOfficeExcel from '@vue-office/excel'
import VueOfficePptx from '@vue-office/pptx'
import '@vue-office/docx/lib/index.css'
import '@vue-office/excel/lib/index.css'
import "datatables.net";
import "datatables.net-bs5";
import VisorCAD2 from "@/components/VisorCAD2.vue"
import DetalleDocumento from "@/components/DetalleDocumento.vue"

export default {
  name: "DocumentoView",
  components: { HeaderMenu, VueOfficeDocx, VueOfficeExcel, VueOfficePdf, VueOfficePptx, VisorCAD2, DetalleDocumento },
  setup() {
    const router = useRouter();
    const route = useRoute(); // Obtiene la información de la ruta actual

    // Accedemos al parámetro de la ruta
    const esquemaId = route.params.esquemaId;
    const registroId = route.params.registroId;

    const esquema = ref({
      propiedades: [], // Inicializar como un array vacío
    });
    const notifications = ref([]);
    const registroSeleccionado = reactive({});
    const tabActiva = ref(1);
    const subTabActiva = ref(0); // 0: Información, 1: Contenido, 2: Versiones
    const pdfSrc = ref("");
    const cargandoGenerarContenido = ref(false);
    const accionGenerarContenido = async () => {
      if (!registroSeleccionado.value || !registroSeleccionado.value.id) {
        showNotification('No hay documento seleccionado.', 'alert-danger');
        return;
      }
      cargandoGenerarContenido.value = true;
      try {
        await axiosInstance.post(`api/procesarOCR/${esquemaId}/${registroSeleccionado.value.id}`);
      } catch (error) {
        showNotification('Error al generar el contenido.', 'alert-danger');
      } finally {
        cargandoGenerarContenido.value = false;
      }
    };

    // Función para cerrar una notificación
    const closeNotification = (index) => {
      notifications.value.splice(index, 1);
    };

    // Estado de los datos de la tabla y los filtros
    const data = ref([]);
    const filteredData = ref([]);
    const searchFilters = reactive({});
    // Paginación
    const pageLength = ref(13);
    const currentPage = ref(1);
    const totalRecords = ref(0);
    const cargando = ref(false);
    // Ordenamiento
    const sortColumn = ref('id');
    const sortDirection = ref('desc');

    const totalPages = computed(() => Math.ceil(totalRecords.value / pageLength.value));
    const paginationRange = computed(() => {
      const range = [];
      const delta = 2; // Número de páginas antes y después de la actual
      const start = Math.max(1, currentPage.value - delta);
      const end = Math.min(totalPages.value, currentPage.value + delta);
      for (let i = start; i <= end; i++) range.push(i);
      return range;
    });

    const hayAcciones = computed(() => {
      return !!(esquema.value?.borrable || esquema.value?.ocr == 1 || esquema.value?.adjuntable);
    });

    // Computed property para agrupar propiedades por grupo y ordenarlas
    const propiedadesAgrupadas = computed(() => {
      if (!esquema.value?.propiedades) return [];

      // Agrupar propiedades por grupo
      const grupos = {};
      esquema.value.propiedades.forEach(propiedad => {
        const grupoNombre = propiedad.grupo || 'Sin grupo';
        if (!grupos[grupoNombre]) {
          grupos[grupoNombre] = {
            nombre: grupoNombre,
            propiedades: []
          };
        }
        grupos[grupoNombre].propiedades.push(propiedad);
      });

      // Convertir a array y ordenar grupos por nombre
      const gruposArray = Object.values(grupos).sort((a, b) => {
        if (a.nombre === 'Sin grupo') return 1;
        if (b.nombre === 'Sin grupo') return -1;
        return a.nombre.localeCompare(b.nombre);
      });

      // Ordenar propiedades dentro de cada grupo por la propiedad 'orden'
      gruposArray.forEach(grupo => {
        grupo.propiedades.sort((a, b) => (a.orden || 0) - (b.orden || 0));
      });

      return gruposArray;
    });

    const changePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
        fetchData();
      }
    };

    const fileUrl = ref('');
    const fileType = ref('');
    const filename = ref('');
    const imgbase64 = ref('');
    const textContent = ref('');
    const docxSrc = ref('');
    const excelSrc = ref('');
    const pptxSrc = ref('');
    const dwgBase64 = ref('');
    const listasDisponibles = ref([]);

    // Función para determinar el tipo de archivo basado en la extensión
    const getFileTypeFromExtension = (extension) => {
      const ext = extension.toLowerCase().replace('.', ''); // Eliminar el punto inicial (si lo tiene)
      if (ext === 'pdf') return 'pdf';
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) return 'image';
      if (['txt', 'log', 'md'].includes(ext)) return 'text';
      if (['docx'].includes(ext)) return 'docx';
      if (['xlsx', 'csv', 'xls'].includes(ext)) return 'xlsx';
      if (['pptx'].includes(ext)) return 'pptx';
      if (['dwg', 'dxf'].includes(ext)) return 'dwg';
      return 'other';
    };



    const detalleDocumento = useTemplateRef('detalleDocumento')

    // Función para obtener los datos del backend
    const fetchEsquema = async () => {
      cargando.value = true; // Activar el spinner
      try {
        const response = await axiosInstance.get("/api/datosesquema/" + esquemaId);
        esquema.value = response.data.esquema;
        if (esquema.value.visualizable === false) {
          router.push('/');
          return;
        }
        searchFilters.value = {
          ...esquema.value.propiedades.reduce((acc, columna) => {
            acc[columna.campoBD] = "";
            return acc;
          }, {})
        };

        // Cargar listas disponibles si hay propiedades de tipo lista
        const tienePropiedadesLista = esquema.value.propiedades.some(prop => prop.tipo === 'list');
        if (tienePropiedadesLista) {
          try {
            const listasResponse = await axiosInstance.get("/api/listas");
            listasDisponibles.value = listasResponse.data.data || [];
          } catch (error) {
            console.error("Error al cargar las listas", error);
            listasDisponibles.value = [];
          }
        }
      } catch (error) {
        console.error("Error fetching data", error);
        showNotification("Error al obtener los datos", 'alert-danger');
      } finally {
        cargando.value = false; // Desactivar el spinner
      }
    };

    // Función para obtener los datos del backend
    const fetchData = async () => {
      cargando.value = true; // Activar el spinner
      try {
        const registroResponse = await axiosInstance.get(`/api/registroesquema/${esquemaId}/${registroId}`);
        registroSeleccionado.value = registroResponse.data.data;
      } catch (error) {
        console.error("Error fetching data", error);
        showNotification("Error al obtener los datos", 'alert-danger');
      } finally {
        cargando.value = false; // Desactivar el spinner
      }
    };

    // Función para cambiar el ordenamiento
    const cambiarOrdenamiento = (columna) => {
      if (sortColumn.value === columna) {
        // Si es la misma columna, cambiar la dirección
        sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
      } else {
        // Si es una nueva columna, establecer como ascendente
        sortColumn.value = columna;
        sortDirection.value = 'asc';
      }
      // Volver a la primera página cuando se cambia el ordenamiento
      currentPage.value = 1;
      fetchData();
    };

    // Función para obtener el icono de ordenamiento
    const getSortIcon = (columna) => {
      if (sortColumn.value !== columna) {
        return 'fa-sort'; // Sin ordenar
      }
      return sortDirection.value === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
    };

    // Cuando cambian los filtros, actualizar la tabla
    //watch(searchFilters, fetchData, {deep: true});
    watch(pageLength, fetchData);
    watch(hayAcciones, (val) => {
      if (!val && tabActiva.value === 2) {
        tabActiva.value = 0;
      }
    });

    onMounted(() => {
      fetchEsquema();
      fetchData();
      cargarEsquemas(); // Cargar esquemas al montar el componente

      




      document.addEventListener("fullscreenchange", () => {
        // Se ejecuta al entrar o salir, incluso con ESC
        isFullscreen.value = !!document.fullscreenElement;
      });
    });

    // Watch para cargar datos cuando cambia el ID del registro seleccionado
    let registroIdAnterior = null
    watch(() => registroSeleccionado.value?.id, async (nuevoId) => {
      const nuevoRegistro = registroSeleccionado.value
      if (nuevoRegistro != null && nuevoId) {
        // Solo recargar el archivo cuando cambia el ID del registro (nuevo registro seleccionado)
        // No recargar si solo cambian las propiedades del mismo registro
        if (registroIdAnterior !== nuevoId) {
          registroIdAnterior = nuevoId
          
          if (detalleDocumento.value) {
            detalleDocumento.value.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          const extension = nuevoRegistro.extension;

          // Limpiar antes de cargar
          fileUrl.value = null;
          fileType.value = null;

          const response = await axiosInstance.get(`api/ficheroRegistro/${esquemaId}/${nuevoRegistro.id}`);

          filename.value = response.data.filename;
          fileType.value = getFileTypeFromExtension(extension);

          if (fileType.value === 'image') {
            imgbase64.value = `data:image/${extension.toLowerCase()};base64,${response.data.base64}`;
          }

          // reset specialized viewers
          textContent.value = '';
          docxSrc.value = '';
          excelSrc.value = '';
          pptxSrc.value = '';
          dwgBase64.value = '';

          fileUrl.value = response.data.base64;
          if (fileType.value === 'pdf') {
            pdfSrc.value = base64ToArrayBuffer(response.data.base64);
          } else {
            pdfSrc.value = '';
          }

          // prepare viewers
          if (fileType.value === 'text') {
            try {
              const array = base64ToUint8Array(response.data.base64);
              const decoder = new TextDecoder('utf-8');
              textContent.value = decoder.decode(array);
            } catch (e) {
              try { textContent.value = atob(response.data.base64); } catch (_) { textContent.value = 'Error al mostrar texto.'; }
            }
          } else if (fileType.value === 'docx') {
            // vue-office soporta ArrayBuffer, Blob, URL. Usamos ArrayBuffer desde base64
            docxSrc.value = base64ToArrayBuffer(response.data.base64);
          } else if (fileType.value === 'xlsx') {
            excelSrc.value = base64ToArrayBuffer(response.data.base64);
          } else if (fileType.value === 'pptx') {
            pptxSrc.value = base64ToArrayBuffer(response.data.base64);
          } else if (fileType.value === 'dwg') {
            dwgBase64.value = response.data.base64;
          }

          fileKey.value++; // fuerza recreación del componente PDF
        }
      }
    });

    const base64ToArrayBuffer = (base64) => {
      const binaryString = atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    };

    const base64ToUint8Array = (base64) => {
      const binaryString = atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes;
    };


    onBeforeUnmount(() => {
      document.removeEventListener("fullscreenchange", () => {
        isFullscreen.value = !!document.fullscreenElement;
      });
    });

    const showNotification = (message, type) => {
      const notification = {
        message,
        class: type,
      };
      notifications.value.push(notification);

      // Cerrar la notificación automáticamente después de 2 segundos
      setTimeout(() => {
        closeNotification(notifications.value.indexOf(notification));
      }, 2000); // 2000 milisegundos = 2 segundos
    };

    // Formatear decimales a un número con precisión fija
    const formatDecimal = (value, digits) => {
      return value ? parseFloat(value).toFixed(digits) : "";
    };
    const formatDate = (value) => {
      if (value) {
        const d = new Date(value);
        return ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
      } else {
        return '';
      }
    };

    const formatDateTime = (value) => {
      if (!value) return '';
      const d = new Date(value);
      const pad = (n) => ("0" + n).slice(-2);
      const day = pad(d.getDate());
      const month = pad(d.getMonth() + 1);
      const year = d.getFullYear();
      const hours = pad(d.getHours());
      const minutes = pad(d.getMinutes());
      const seconds = pad(d.getSeconds());
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };

    // Actualizar decimales en el modelo
    const updateDecimal = (campo, event, digits) => {
      // Usar valueAsNumber que devuelve el valor numérico directamente para inputs type="number"
      const parsedValue = event.target.valueAsNumber;
      // Si el campo está vacío o no es un número válido, establecer null
      if (isNaN(parsedValue) || parsedValue === null || parsedValue === undefined) {
        registroSeleccionado.value[campo] = null;
        return;
      }
      // Redondear solo al final con el número de decimales especificado
      const multiplier = Math.pow(10, digits);
      const newValue = Math.round(parsedValue * multiplier) / multiplier;
      registroSeleccionado.value[campo] = newValue;
    };

    const guardarRegistro = async () => {
      cargando.value = true; // Activar el spinner
      try {
        const resp = await axiosInstance.post("/api/registroesquema/" + esquemaId, { registro: registroSeleccionado.value });
        registroSeleccionado.value = resp.data.registro;
        showNotification('Documento guardado.', 'alert-success');
      } catch (error) {
        console.error("Error fetching data", error);
        showNotification("Error al obtener los datos", 'alert-danger');
      } finally {
        cargando.value = false; // Desactivar el spinner
      }
    };

    const modalRef = ref(null); // Referencia al modal


    const archivo = reactive({});
    const isDragging = reactive(false);
    const fileInput = ref(null);
    const triggerFileInput = () => {
      // Dispara el clic en el input de archivo
      fileInput.value.click();
    };


    const obtenerMimeDesdeExtension = (filename) => {
      const extension = filename.split('.').pop().toLowerCase();

      const mimeTypes = {
        pdf: 'application/pdf',
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        gif: 'image/gif',
        svg: 'image/svg+xml',
        txt: 'text/plain',
        csv: 'text/csv',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        zip: 'application/zip',
        json: 'application/json'
        // Agrega más si los necesitas
      };

      return mimeTypes[extension] || 'application/octet-stream';
    }

    // Nota: la gestión de listas (tipo list) se hace en el componente `DetalleDocumento`.

    // Función para formatear el nombre de la propiedad (reemplazar _ por espacios)
    const formatearNombrePropiedad = (nombre) => {
      if (!nombre) return '';
      return nombre.replace(/_/g, ' ');
    };

    // Función para obtener el icono del archivo según su extensión
    const getFileIcon = () => {
      // Intentar obtener la extensión del registro seleccionado
      let extension = '';
      
      if (registroSeleccionado.value?.extension) {
        extension = registroSeleccionado.value.extension.toLowerCase().replace('.', '');
      } else if (filename.value) {
        // Si no hay extensión directa, intentar extraerla del filename
        const partes = filename.value.split('.');
        if (partes.length > 1) {
          extension = partes[partes.length - 1].toLowerCase();
        }
      }

      // Mapeo de extensiones a iconos
      const iconMap = {
        'pdf': '/img/files/fi-pdf.svg',
        'jpg': '/img/files/fi-jpg.svg',
        'jpeg': '/img/files/fi-jpg.svg',
        'png': '/img/files/fi-jpg.svg',
        'gif': '/img/files/fi-jpg.svg',
        'bmp': '/img/files/fi-jpg.svg',
        'webp': '/img/files/fi-jpg.svg',
        'txt': '/img/files/fi-txt.svg',
        'csv': '/img/files/fi-csv.svg',
        'xlsx': '/img/files/fi-xlsx.svg',
        'xls': '/img/files/fi-xls.svg',
        'docx': '/img/files/fi-docx.svg',
        'doc': '/img/files/fi-doc.svg',
        'zip': '/img/files/fi-zip.svg',
        'json': '/img/files/fi-json.svg'
      };

      // Retornar el icono correspondiente o el icono por defecto
      return iconMap[extension] || '/img/files/any-file.png';
    };

    // Función para obtener el texto alternativo del icono
    const getFileIconAlt = () => {
      let extension = '';
      if (registroSeleccionado.value?.extension) {
        extension = registroSeleccionado.value.extension.toLowerCase().replace('.', '');
      } else if (filename.value) {
        const partes = filename.value.split('.');
        if (partes.length > 1) {
          extension = partes[partes.length - 1].toLowerCase();
        }
      }
      return extension ? `Archivo ${extension.toUpperCase()}` : 'Archivo';
    };

    const descargarArchivo = () => {
      const mime = obtenerMimeDesdeExtension(filename.value);
      const enlace = document.createElement('a');
      enlace.href = `data:${mime};base64,` + fileUrl.value;
      enlace.download = filename.value;
      document.body.appendChild(enlace);
      enlace.click();
      document.body.removeChild(enlace);
    }

    const fullscreenDiv = ref(null)
    const isFullscreen = ref(false)
    const pantallaCompleta = () => {
      const elem = fullscreenDiv.value

      if (!document.fullscreenElement) {
        elem.requestFullscreen().then(() => {
          isFullscreen.value = true
        }).catch(err => {
          console.error(`Error al intentar pantalla completa: ${err.message}`)
        })
      } else {
        document.exitFullscreen().finally(() => {
          isFullscreen.value = false
        })
      }
    }

        const abrirDocumentoEnNuevaPestana = () => {
      if (!registroSeleccionado.value?.id) return;
      
      const url = `/esquema/${esquemaId}/registro/${registroSeleccionado.value.id}`;
      window.open(url, '_blank');
    }

    const copiarEnlace = async () => {
      if (!registroSeleccionado.value?.id) return;
      
      const url = `${window.location.origin}/esquema/${esquemaId}/registro/${registroSeleccionado.value.id}`;
      
      try {
        await navigator.clipboard.writeText(url);
        showNotification('Enlace copiado al portapapeles', 'alert-success');
      } catch (error) {
        // Fallback para navegadores que no soportan clipboard API
        const textArea = document.createElement('textarea');
        textArea.value = url;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        showNotification('Enlace copiado al portapapeles', 'alert-success');
      }
    }

    const fileKey = ref(0);
    const mostrarModalEliminar = ref(false);
    const confirmarEliminar = async () => {
      mostrarModalEliminar.value = false;
      try {
        await axiosInstance.post(`/api/borrarregistro/${esquemaId}`, { registro: registroSeleccionado.value });
        showNotification('Registro eliminado.', 'alert-success');
        await fetchData();
        registroSeleccionado.value = null;
      } catch (error) {
        showNotification('Error al eliminar el registro.', 'alert-danger');
      }
    };
    const onEliminarRegistro = async (registro) => {
      try {
        await axiosInstance.post(`/api/borrarregistro/${esquemaId}`, { registro });
        showNotification('Registro eliminado.', 'alert-success');
        await fetchData();
        registroSeleccionado.value = null;
      } catch (error) {
        showNotification('Error al eliminar el registro.', 'alert-danger');
      }
    };

    const textoOcr = ref('');
    const cargandoOcr = ref(false);
    const abrirOcrTab = async () => {
      if (esquema.value.ocr != 1) return;
      tabActiva.value = 3;
      subTabActiva.value = 1;
      if (!registroSeleccionado.value || !registroSeleccionado.value.id) {
        textoOcr.value = 'No hay documento seleccionado.';
        return;
      }
      cargandoOcr.value = true;
      textoOcr.value = '';
      try {
        const response = await axiosInstance.get(`api/ocrRegistro/${esquemaId}/${registroSeleccionado.value.id}`);
        textoOcr.value = response.data || 'Sin texto OCR disponible.';
      } catch (error) {
        textoOcr.value = 'Error al obtener el texto OCR.';
      } finally {
        cargandoOcr.value = false;
      }
    };

    const seleccionarOtros = async (idx) => {
      tabActiva.value = 3;
      await abrirSubTab(idx);
    };

    const versiones = ref([]);
    const cargandoVersiones = ref(false);
    const abrirSubTab = async (idx) => {
      if (idx === 2 && esquema.value.versionado != 1) return;
      if (idx === 1 && esquema.value.ocr != 1) return;
      if (idx === 3 && esquema.value.documentos_relacionados != 1) return;
      if (idx === 4 && esquema.value.firmar_documentos != 1) return;
      if (idx === 5 && esquema.value.firmar_documentos_vidsigner != 1) return;
      subTabActiva.value = idx;
      if (idx === 1) {
        await abrirOcrTab();
      } else if (idx === 2) {
        await cargarVersiones();
      } else if (idx === 3) {
        await cargarRelacionados();
      } else if (idx === 0) {
        // Información
        await cargarLogs();
      }
      // Los índices 4 y 5 (firmar documentos) no necesitan carga adicional, solo mostrar el componente
    };

    const cargarVersiones = async () => {
      if (!registroSeleccionado.value || !registroSeleccionado.value.id) return;
      cargandoVersiones.value = true;
      try {
        const response = await axiosInstance.get(`api/versionesRegistro/${esquemaId}/${registroSeleccionado.value.id}`);
        versiones.value = response.data || [];
      } catch (e) {
        versiones.value = [];
      } finally {
        cargandoVersiones.value = false;
      }
    };

    const descargarVersion = (ver) => {
      if (!ver || !ver.base64 || !ver.nombre) return;
      const mime = obtenerMimeDesdeExtension(ver.nombre);
      const enlace = document.createElement('a');
      enlace.href = `data:${mime};base64,` + ver.base64;
      enlace.download = ver.nombre;
      document.body.appendChild(enlace);
      enlace.click();
      document.body.removeChild(enlace);
    };

    // Documentos Relacionados
    const documentosRelacionados = ref([]);
    const cargandoRelacionados = ref(false);
    const mostrarModalRelacionar = ref(false);
    const resultadosBusqueda = ref([]);
    const cargandoBusqueda = ref(false);
    const relacionando = ref(false);
    const generandoDocumento = ref(false);
    const busquedaTermino = ref('');
    const busquedaPaginacion = ref({ page: 1, per_page: 10, total: 0 });
    const esquemasDisponibles = ref([]); // Lista de esquemas para mostrar nombres
    const esquemaBuscar = ref(null); // Esquema seleccionado para búsqueda

    // Cargar lista de esquemas disponibles
    const cargarEsquemas = async () => {
      try {
        const response = await axiosInstance.get('/api/esquemas');
        esquemasDisponibles.value = response.data.esquemas || [];
      } catch (e) {
        console.error('Error al cargar esquemas:', e);
        esquemasDisponibles.value = [];
      }
    };

    // Obtener nombre del esquema por ID
    const getEsquemaNombre = (esquemaId) => {
      if (!esquemaId) return '';
      const esquema = esquemasDisponibles.value.find(e => e.id === esquemaId);
      return esquema ? esquema.nombre : `Esquema ${esquemaId}`;
    };

    const cargarRelacionados = async () => {
      if (!registroSeleccionado.value || !registroSeleccionado.value.id) return;
      cargandoRelacionados.value = true;
      try {
        const response = await axiosInstance.get(`api/documentosRelacionados/${esquemaId}/${registroSeleccionado.value.id}`);
        documentosRelacionados.value = response.data.data || [];
      } catch (e) {
        documentosRelacionados.value = [];
      } finally {
        cargandoRelacionados.value = false;
      }

    };
    // Lanzar búsqueda automática al abrir el modal
    watch(mostrarModalRelacionar, (val) => {
      if (val) {
        cargarEsquemas(); // Cargar esquemas al abrir el modal
        buscarDocumentos(1);
      }
    });

    const buscarDocumentos = async (page = 1) => {
      cargandoBusqueda.value = true;
      try {
        const params = { 
          q: busquedaTermino.value, 
          page, 
          per_page: busquedaPaginacion.value.per_page 
        };
        // Agregar esquema_buscar si está seleccionado
        if (esquemaBuscar.value) {
          params.esquema_buscar = esquemaBuscar.value;
        }
        const response = await axiosInstance.get(`api/buscarDocumentos/${esquemaId}/${registroSeleccionado.value.id}`, { params });
        resultadosBusqueda.value = response.data.data || response.data;
        busquedaPaginacion.value = response.data.pagination || { page, per_page: busquedaPaginacion.value.per_page, total: 0 };
      } catch (e) {
        resultadosBusqueda.value = [];
        busquedaPaginacion.value = { page, per_page: busquedaPaginacion.value.per_page, total: 0 };
      } finally {
        cargandoBusqueda.value = false;
      }
    };

    const relacionarDocumento = async (doc) => {
      if (!doc || !registroSeleccionado.value?.id) return;
      relacionando.value = true;
      try {
        const body = { 
          documento_id: doc.id,
          esquema_rel_id: doc.esquema_id || esquemaId
        };
        await axiosInstance.post(`api/relacionarDocumento/${esquemaId}/${registroSeleccionado.value.id}`, body);
        await cargarRelacionados();
        mostrarModalRelacionar.value = false;
        resultadosBusqueda.value = [];
        busquedaTermino.value = '';
      } catch (e) {
        // noop
      } finally {
        relacionando.value = false;
      }
    };

    const irAVerDocumentoRelacionado = (doc) => {
      if (!doc || !doc.id) return;
      // Usar esquema_id del documento si está disponible, sino usar el esquema actual
      const esquemaIdDoc = doc.esquema_id || esquemaId;
      const url = `/esquema/${esquemaIdDoc}/registro/${doc.id}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    };

    const descargarDocumentoRelacionado = async (doc) => {
      if (!doc || !doc.id) return;
      try {
        // Usar esquema_id del documento si está disponible, sino usar el esquema actual
        const esquemaIdDoc = doc.esquema_id || esquemaId;
        const response = await axiosInstance.get(`api/descargarRelacionado/${esquemaIdDoc}/${doc.id}`);
        const nombre = response.data?.nombre || doc.nombre || 'documento';
        const mime = obtenerMimeDesdeExtension(nombre);
        const enlace = document.createElement('a');
        enlace.href = `data:${mime};base64,` + response.data.base64;
        enlace.download = nombre;
        document.body.appendChild(enlace);
        enlace.click();
        document.body.removeChild(enlace);
      } catch (e) {
        console.log(e);
      }
    };

    const quitarDocumentoRelacionado = async (doc) => {
      if (!doc || !doc.id || !registroSeleccionado.value?.id) return;
      try {
        // Incluir esquema_id del documento en el body si está disponible
        const body = { documento_id: doc.id };
        if (doc.esquema_id) {
          body.esquema_id = doc.esquema_id;
        }
        await axiosInstance.post(`api/quitarRelacionado/${esquemaId}/${registroSeleccionado.value.id}`, body);
        await cargarRelacionados();
      } catch (e) {
        console.log(e);
      }
    };

    const cerrarRelacionar = () => {
      mostrarModalRelacionar.value = false;
      resultadosBusqueda.value = [];
      busquedaTermino.value = '';
      esquemaBuscar.value = null; // Resetear filtro de esquema
    };

    const seleccionarRegistro = (item) => {
      registroSeleccionado.value = item;
      tabActiva.value = 0;
    };

    const mostrarModalRemplazar = ref(false);
    const fileRemplazo = ref(null);
    const fileRemplazoBase64 = ref("");
    const onFileChangeRemplazar = (e) => {
      const file = e.target.files[0];
      if (!file) {
        fileRemplazo.value = null;
        fileRemplazoBase64.value = "";
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        fileRemplazoBase64.value = event.target.result.split(",")[1]; // solo base64
        fileRemplazo.value = file;
      };
      reader.readAsDataURL(file);
    };
    const cancelarRemplazar = () => {
      mostrarModalRemplazar.value = false;
      fileRemplazo.value = null;
      fileRemplazoBase64.value = "";
    };
    const guardarRemplazo = async () => {
      if (!fileRemplazo.value || !fileRemplazoBase64.value) return;
      try {
        await axiosInstance.post(`api/remplazarDocumento/${esquemaId}/${registroSeleccionado.value.id}`, {
          archivo: fileRemplazoBase64.value,
          nombre: fileRemplazo.value.name,
          tipo: fileRemplazo.value.type
        });
        mostrarModalRemplazar.value = false;
        fileRemplazo.value = null;
        fileRemplazoBase64.value = "";
        showNotification('Documento reemplazado correctamente.', 'alert-success');
        // Actualizar la extensión del registro seleccionado con la del nuevo archivo
        const nuevaExtension = (fileRemplazo.value?.name || '').split('.').pop()?.toLowerCase();
        if (nuevaExtension) {
          registroSeleccionado.value.extension = nuevaExtension;
        }
        const oldSeleccionadoValue = registroSeleccionado.value;
        registroSeleccionado.value = null;
        registroSeleccionado.value = oldSeleccionadoValue;
        if (registroSeleccionado.value != null) {
          if (detalleDocumento.value) {
            detalleDocumento.value.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          const extension = registroSeleccionado.value.extension;

          // Limpiar antes de cargar
          fileUrl.value = null;
          fileType.value = null;

          const response = await axiosInstance.get(`api/ficheroRegistro/${esquemaId}/${registroSeleccionado.value.id}`);

          filename.value = response.data.filename;
          fileType.value = getFileTypeFromExtension(extension);

          if (fileType.value === 'image') {
            imgbase64.value = `data:image/${extension.toLowerCase()};base64,${response.data.base64}`;
          }

          fileUrl.value = response.data.base64;
          fileKey.value++; // fuerza recreación del componente PDF
        }
      } catch (error) {
        showNotification('Error al reemplazar el documento.', 'alert-danger');
      }
    };

    const generarDesdePlantilla = async () => {
      if (!registroSeleccionado.value || !registroSeleccionado.value.id) {
        showNotification('No hay registro seleccionado.', 'alert-warning');
        return;
      }

      if (!confirm('¿Desea generar un nuevo documento desde la plantilla? Esto ' + 
        (esquema.value.versionado == 1 ? 'creará una nueva versión' : 'reemplazará el documento actual') + '.')) {
        return;
      }

      generandoDocumento.value = true;
      try {
        const response = await axiosInstance.post(
          `api/generarDocumentoDesdePlantilla/${esquemaId}/${registroSeleccionado.value.id}`
        );

        if (response.data.success) {
          showNotification('Documento generado correctamente desde la plantilla.', 'alert-success');
          // Recargar el registro para mostrar el nuevo documento
          await fetchData();
          // Forzar recarga del archivo
          fileKey.value++;
        } else {
          showNotification(response.data.error || 'Error al generar el documento.', 'alert-danger');
        }
      } catch (error) {
        const mensaje = error.response?.data?.error || 'Error al generar el documento desde la plantilla.';
        showNotification(mensaje, 'alert-danger');
      } finally {
        generandoDocumento.value = false;
      }
    };

    const logs = ref([]);
    const cargandoLogs = ref(false);
    const cargarLogs = async () => {
      if (!registroSeleccionado.value || !registroSeleccionado.value.id) return;
      cargandoLogs.value = true;
      try {
        const response = await axiosInstance.get(`api/logRegistro/${esquemaId}/${registroSeleccionado.value.id}`);
        logs.value = response.data.data || [];
      } catch (e) {
        logs.value = [];
      } finally {
        cargandoLogs.value = false;
      }
    };

    const handleActualizarRegistro = (registroActualizado) => {
      // Actualizar el registro seleccionado con los nuevos datos
      if (registroSeleccionado.value && typeof registroSeleccionado.value === 'object') {
        Object.assign(registroSeleccionado.value, registroActualizado)
      } else {
        registroSeleccionado.value = registroActualizado
      }
    }

    return {
      esquema,
      esquemaId,
      notifications,
      closeNotification,
      registroSeleccionado,
      tabActiva,
      pdfSrc,
      fetchData,
      data,
      filteredData,
      searchFilters,
      pageLength,
      currentPage,
      totalRecords,
      formatDecimal,
      formatDate,
      formatDateTime,
      updateDecimal,
      totalPages,
      paginationRange,
      changePage,
      cargando,
      guardarRegistro,
      modalRef,
      archivo,
      isDragging,
      fileInput,
      triggerFileInput,
      fileUrl,
      fileType,
      descargarArchivo,
      imgbase64,
      textContent,
      docxSrc,
      excelSrc,
      pptxSrc,
      isFullscreen,
      fullscreenDiv,
      pantallaCompleta,
      abrirDocumentoEnNuevaPestana,
      copiarEnlace,
      fileKey,
      mostrarModalEliminar,
      confirmarEliminar,
      onEliminarRegistro,
      accionGenerarContenido,
      textoOcr,
      cargandoOcr,
      abrirOcrTab,
      cargandoGenerarContenido,
      seleccionarRegistro,
      subTabActiva,
      abrirSubTab,
      versiones,
      cargandoVersiones,
      descargarVersion,
      documentosRelacionados,
      cargandoRelacionados,
      mostrarModalRelacionar,
      resultadosBusqueda,
      cargandoBusqueda,
      relacionando,
      generandoDocumento,
      busquedaTermino,
      cargarRelacionados,
      buscarDocumentos,
      relacionarDocumento,
      irAVerDocumentoRelacionado,
      descargarDocumentoRelacionado,
      quitarDocumentoRelacionado,
      cerrarRelacionar,
      esquemasDisponibles,
      esquemaBuscar,
      handleActualizarRegistro,
      showNotification,
      cargarEsquemas,
      getEsquemaNombre,
      hayAcciones,
      mostrarModalRemplazar,
      fileRemplazo,
      fileRemplazoBase64,
      onFileChangeRemplazar,
      cancelarRemplazar,
      guardarRemplazo,
      generarDesdePlantilla,
      seleccionarOtros,
      filename,
      busquedaPaginacion,
      logs,
      cargandoLogs,
      // Variables para listas
      listasDisponibles,
      // Funciones de formateo
      formatearNombrePropiedad,
      getFileIcon,
      getFileIconAlt,
      // Computed properties
      propiedadesAgrupadas,
      // Variables de ordenamiento
      sortColumn,
      sortDirection,
      // Funciones de ordenamiento
      cambiarOrdenamiento,
      getSortIcon,
    };
  },
}
</script>

<style scoped>
/* Evitar que el accordion recorte el dropdown de listas */
.accordion-dropdown-open .accordion-item {
  overflow: visible !important;
}
.accordion-dropdown-open .accordion-collapse {
  overflow: visible !important;
}
.accordion-dropdown-open .accordion-body {
  overflow: visible !important;
}
.list-dropdown-open {
  z-index: 1100;
  position: relative;
}

.pdf-container {
  height: 70vh;
  width: 100%;
  overflow: auto;
  border: 1px solid #ccc;
}

.pdf-container-completa {
  height: 100dvh;
  width: 100%;
  overflow: auto;
  border: 1px solid #ccc;
}

.pptx-container {
  height: 70vh;
  width: 100%;
  overflow: auto;
  border: 1px solid #ccc;
  position: relative;
}

.pptx-container-completa {
  height: 100vh;
  width: 100vw;
  overflow: auto;
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background: white;
}

.image-container img {
  max-width: 100%;
  height: auto;
}

.file-container {
  margin-top: 16px;
}

.nav-tabs-nowrap {
  flex-wrap: nowrap !important;
  overflow-x: auto;
  white-space: nowrap;
}

.nav-tabs-nowrap .nav-item {
  float: none;
  display: inline-block;
}

/* Evitar scroll vertical en las pestañas */
.nav-tabs {
  overflow-y: visible !important;
}

/* Scroll vertical solo en el contenido de la pestaña 'Contenido' */
.ocr-content-scroll {
  max-height: 70vh;
  overflow-y: auto;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 1rem;
}

.celda-ellipsis {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Subpestañas que "abren" hacia arriba */
.subtabs-bottom {
  border-top: 1px solid #dee2e6;
  border-bottom: none;
}

.subtabs-bottom .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
  border-bottom: none;
  color: #5e72e4;
}

.subtabs-bottom .nav-link:hover {
  border-color: transparent;
}

.subtabs-bottom .nav-link.active {
  color: #344767;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 transparent;
  border-bottom: 1px solid #fff;
  /* se funde con el panel superior */
}

/* Forzar que el header y el dropdown se muestren sobre el body y ocultar scroll del header */
.card-header {
  position: relative;
  z-index: 3;
  overflow: visible !important;
}

.card-body {
  position: relative;
  z-index: 1;
}

.nav-tabs {
  overflow: visible !important;
}

.dropdown-menu {
  position: absolute;
  z-index: 1055;
  /* por encima del body */
}

/* Estilos para el accordion de propiedades */
.accordion-item {
  border: 1px solid #dee2e6;
  margin-bottom: 8px;
  border-radius: 0.375rem;
  overflow: hidden;
}

.accordion-item:last-child {
  margin-bottom: 0;
}

.accordion-button {
  background-color: #f8f9fa;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  color: #495057;
  padding: 1rem 1.25rem;
}

.accordion-button:not(.collapsed) {
  background-color: #e9ecef;
  color: #212529;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.accordion-button:focus {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  border-color: #86b7fe;
}

.accordion-button::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  transition: transform 0.2s ease-in-out;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
}

.accordion-button:not(.collapsed)::after {
  transform: rotate(180deg);
}

.accordion-body {
  padding: 1.25rem;
  background-color: #fff;
}

.accordion-collapse {
  border-top: 1px solid #dee2e6;
}

/* Estilos para headers ordenables */
.sortable-header {
  transition: color 0.2s ease;
}

.sortable-header:hover {
  color: #0d6efd !important;
}

.sortable-header i {
  font-size: 0.8em;
  opacity: 0.7;
}

.sortable-header:hover i {
  opacity: 1;
}

/* Modal de relacionar documento - 50% más ancho que modal-lg */
.modal-relacionar {
  max-width: calc(800px * 1.5) !important;
  width: calc(800px * 1.5) !important;
}

@media (max-width: 1200px) {
  .modal-relacionar {
    max-width: 95vw !important;
    width: 95vw !important;
  }
}

/* Botones más pequeños para documentos relacionados */
.btn-xs {
  padding: 0.15rem 0.4rem;
  font-size: 0.75rem;
  line-height: 1.2;
  border-radius: 0.2rem;
}
</style>
